import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from 'src/makeStyles';
import { StaticGoogleMap, Marker } from 'react-static-google-map';
import ImageTag from '../ImageTag';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    '& img': {
      display: 'block',
      width: '100%',
      height: '100%',
      margin: 'auto',
    },
  },
}));

const StaticGoogleMapView = ({ size, location, className, zoom }) => {
  const { classes, cx } = useStyles();

  return (
    <div className={cx(classes.root, className)}>
      <StaticGoogleMap
        size={size}
        className="img-fluid"
        zoom={zoom}
        apiKey={process.env.GOOGLE_MAPS_KEY}
        as={props => <ImageTag {...props} alt="location" />}
      >
        <Marker location={location} color="red" size="tiny" />
      </StaticGoogleMap>
    </div>
  );
};

StaticGoogleMapView.propTypes = {
  size: PropTypes.string,
  location: PropTypes.string,
  className: PropTypes.string,
  zoom: PropTypes.string,
};

export default StaticGoogleMapView;
